import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const Agreements = Loadable({
    loader: () => import('./Agreements'),
    render(loaded, props) {
      const Component = connect((state) => ({
        agreementsState: state.agreementsState,
        siteConfig: state.siteConfig
      }), {
        init
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path='/agreements/:agreement'
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Agreements {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
